import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
// Admin JWT is short-lived (12h expiry, server-signed with HS256) and rotates per login.
// Server re-validates on every /api/admin/* call. Storing in localStorage is acceptable
// for this internal-only dashboard; if XSS becomes a concern, switch to httpOnly cookies.
const TOKEN_KEY = "sal_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const adminApi = axios.create({ baseURL: API });
adminApi.interceptors.request.use((cfg) => {
  const token = getToken();
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export const login = async (email, password) => {
  const { data } = await axios.post(`${API}/admin/login`, { email, password });
  setToken(data.token);
  return data;
};

export const logout = () => clearToken();

export const isAuthed = () => !!getToken();
